export { Terminal2 as default } from './Terminal2';
